module.exports = __webpack_public_path__ + "media/images/adp-logo-d181cb6a453604ccdde94e2efeb8fcd6.svg";